
import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;

export const fetchOpportunityId = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "commercial_opportunity_select",
            'action': "SELECT_BY_ID",
            "findOne": "true",
            'variables': JSON.stringify({
                'id': data
            })
        })
    });
};


export const insertOpportunity = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "commercial_opportunity_alter",
            'action': "INSERT",
            'variables': data
        })
    });
};

export const updateOpportunity = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: "commercial_opportunity_alter",
            action: "UPDATE",
            variables: data
        })
    });
};
export const fetchProductsOpportunity = (id, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: "commercial_opportunity_products_select",
            action: "SELECT_BY_COMMERCIAL_OPPORTUNITY",
            variables: JSON.stringify({id})
        })
    });
};
export const fecthProductsPrBusinessLine = (idCompany, businessLine, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: "commercial_opportunity_products_select",
            action: "SELECT_PRODUCTS_BY_BUSINESS_LINE",
            variables: JSON.stringify({"id_company":idCompany, "business_line":businessLine})
        })
    });
};